<template>
    <NavBar></NavBar>
    <div class="grid" v-if="globes" >
      <!-- columns -->
      <div class="grid-col grid-col--1"></div>
      <div class="grid-col grid-col--2"></div>
      <div class="grid-col grid-col--3"></div>
      <div class="grid-col grid-col--4"></div>
      <div class="grid-col grid-col--5"></div>
      <div class="grid-col grid-col--6"></div>
      <div v-if="globes" v-for="globe in globes.globes" v-bind:key="globe.id" class="grid-item">
        <router-link class="grid-link" :to="'globe_' + globe.id">
          <img v-bind:src="require('@/assets/thumb/'+ globe.image)" class="globe-img">  
          <div class="globe-info">
            <p class="globe-name">{{globe.name}}</p>
            <p class="globe-author">{{globe.author}}</p>
            <p class="globe-date">{{globe.date}}</p>
          </div>
        </router-link>
      </div>
    </div>
    <!--<div v-if="globes" id="globe-container" class="container-fluid">
        <div class="row">
          <div v-for="globe in globes.globes" v-bind:key="globe.id" class="col-xl-2 col-md-3 col-sm-6 col-12 globe-card">
            <img v-bind:src="require('@/assets/globes/'+ globe.image)" class="globe-img">  
            <div v-bind:style="'background-image: url(' + require('@/assets/globes/'+ globe.image) + ')'" class="globe-div"></div>
          </div>
        </div>
    </div>-->
</template>
  
<script>
  import NavBar from "../components/NavBar.vue"
  import Colcade from "colcade/colcade.js"

  export default {
    name: 'GlobesPage',
    components: {
        NavBar
    },
    data(){
    return{
        globes:null
      }
    },
    created(){
      this.fetchData();
    },    
    watch:{
        '$route':'fetchData'
    },
    methods:{
      fetchData(){
        let self = this;  

        var fileName = "./globes.json";
        const myRequest = new Request(fileName);

        fetch(myRequest)
            .then(res => res.json())
            .then(data => {
                self.globes = data;
              })
            .then(d => {
                var grid = document.querySelector('.grid');
                var colc = new Colcade( grid, {
                  columns: '.grid-col',
                  items: '.grid-item'
                });
              }
            )
            .catch(function(error) {
              console.log('Request failed', error)
            });
      }
    }
  }
</script>

<style scoped>
  .globe-div{
    width:100%;
    height:300px;
    margin-top:20px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center; 
  }
  .globe-img{
    width:100%;
  }
  /* masonry grid with flexbox */
  .grid {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-top:10px;
  }
  .grid-col {
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }
  .grid-item{
    padding:10px;
    position:relative;
  }
  .grid-item:hover{
    cursor:pointer;
  }
  .grid-link:hover > img{
    border:2px solid black;
    opacity:0.2;
  }
  .grid-link:hover > .globe-info {
    display:block;
  }
  .globe-info{
    color:black;
    position:absolute;
    top:15px;
    left:20px;
    display:none;
    width:calc(100% - 15px);
  }
  .globe-name{
    font-size:24px;
    line-height:28px;
    font-weight:bold;
    margin-bottom:0;
    width:calc(100% - 15px);
  }
  .globe-author{
    font-size:18px;
    margin-bottom:0;
    width:calc(100% - 15px);
  }
  .globe-date{
    font-size:18px;
    font-style: italic;
  }
  /* 1 column by default, hide others */
  .grid-col--2, .grid-col--3, .grid-col--4, .grid-col--5, .grid-col--6 { display: none }
  /* 2 columns at small size */
  @media (max-width:768px){
    .globe-info{
      display:block;
      position:relative;
    }
  }
  @media ( min-width: 576px ) {
    .grid-col--2 { display: block; } /* show column 2 */
    
  }
  @media ( min-width: 768px ) {
    .grid-col--3, .grid-col--4{ display: block; } /* show column 2 */
  }
  /* 4 columns at large size */
  @media ( min-width: 1200px ) {
    .grid-col--5, .grid-col--6 { display: block; } /* show column 3 */
  }
</style>